import { render, staticRenderFns } from "./ViewLogs.vue?vue&type=template&id=9a44bba0&scoped=true&"
import script from "./ViewLogs.vue?vue&type=script&lang=js&"
export * from "./ViewLogs.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/components/timeline/custom-timeline.css?vue&type=style&index=0&id=9a44bba0&scoped=true&lang=css&"
import style1 from "./ViewLogs.vue?vue&type=style&index=1&id=9a44bba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a44bba0",
  null
  
)

export default component.exports